import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import {
  Table,
  Input,
  Button,
  Tag,
  Dropdown,
  Select,
  Menu,
  Popover,
  Popconfirm,
  Avatar,
  Modal,
  Divider,
  DatePicker
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faMapMarked, faTimesCircle } from '@fortawesome/pro-duotone-svg-icons';
import { ClockCircleOutlined } from '@ant-design/icons';
import {
  notificationsAtom,
  viewLeadAtom,
  viewLeadLogsAtom,
  createNewLeadAtom,
  viewLeadFilesAtom,
  viewContactsAtom,
  userPrivilagesAtom,
  reloadLeadsAtom,
  myLeadsHeaderAtom,
  viewLeadAssignedAtom,
  assignOrgAtom,
  userAtom,
  editCommissionsAtom,
  viewPayoutAtom,
  viewAppointmentsAtom
} from '../../../../../atoms/Atoms';
import api from '../../../../../api/api';
import {
  mapLeadStatus,
  mapLeadStage,
  mapLeadProgress,
  mapLeadProgressColor,
  mapDealType,
  thousand,
  getWaitTime,
  getWaitTimeText,
  toFormattedLocalTime,
  hasBillFileType,
  toCurrency
} from '../../../../../functions';
import LeadProgress from '../../../../shared-components/leadprogress/LeadProgress';

function LeadsSearchTable({ searchType, orgReferral, useGlobal, isSetter, className }) {
  const { t } = useTranslation();
  const { Option } = Select;
  const setView = useSetRecoilState(viewLeadAtom);
  const setViewAppointments = useSetRecoilState(viewAppointmentsAtom);
  const setViewLogs = useSetRecoilState(viewLeadLogsAtom);
  const setViewFiles = useSetRecoilState(viewLeadFilesAtom);
  const setViewContacts = useSetRecoilState(viewContactsAtom);
  const setAssignOrg = useSetRecoilState(assignOrgAtom);
  const user = useRecoilValue(userAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const setViewAssigned = useSetRecoilState(viewLeadAssignedAtom);
  const setEditCommissions = useSetRecoilState(editCommissionsAtom);
  const [myLeadsHeader, setMyLeadsHeader] = useRecoilState(myLeadsHeaderAtom);
  const [reloadLeads, setReloadLeads] = useRecoilState(reloadLeadsAtom);
  const setViewPayout = useSetRecoilState(viewPayoutAtom);
  const [createNewLead, setCreateNewLead] = useRecoilState(createNewLeadAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [loading, setLoading] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [searchResult, setSearchResult] = useState(null);
  const [selectedCloserId, setSelectedCloserId] = useState('');
  const [selectedSetterId, setSelectedSetterId] = useState('');
  const [openSetter, setOpenSetter] = useState(false);
  const [leadData, setLeadData] = useState(null);
  const [setters, setSetters] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [selectedSort, setSelectedSort] = useState(0);
  const [revertingLost, setRevertingLost] = useState(false);

  function search(value, page) {
    if (loading) {
      return;
    }
    setLoading(true);
    setLastSearchTerm(value);
    setCurrentPage(page);
    setMyLeadsHeader({
      ...myLeadsHeader,
      loading: true
    });
    let searchAssigned = true;
    let searchSetter = false;
    if (useGlobal) {
      searchAssigned = false; 
    }
    if (isSetter) {
      searchAssigned = false;
      searchSetter = true;
    }
    let url = 'leads/search';
    if (orgReferral) {
      url = 'leads/org/search';
    }
    api
      .post(
        url,
        {
          Query: value,
          Size: pageSize,
          Page: page,
          Type: 0,
          Filter: searchType,
          OrgReferralCode: orgReferral,
          SearchAssigned: searchAssigned,
          CloserId: selectedCloserId,
          SetterId: searchSetter ? user?.id : selectedSetterId,
          MySetter: searchSetter,
          Sort: selectedSort
        }
      )
      .then((response) => {
        setLoading(false);
        setMyLeadsHeader({
          ...myLeadsHeader,
          loading: false
        });
        if (response?.data?.success) {
          setSearchResult({
            ...response.data.data,
            submissions: _.map(response.data.data.submissions, (s) => ({
              ...s,
              hasCloser: _.filter(s?.assignments, (a) => a.ownershipType === 0).length > 0
            }))
          });
           console.log('searchResult', response.data.data);
          setMyLeadsHeader({
            ...myLeadsHeader,
            setters: response?.data?.data?.setters,
            closers: response?.data?.data?.closers,
            orgLeadsInfos: response?.data?.data?.orgLeadsInfos,
            totalRevisit: response?.data?.data?.totalRevisit,
            totalFailedCredit: response?.data?.data?.totalFailedCredit,
            totalPending: response?.data?.data?.totalPending,
            totalAssigned: response?.data?.data?.totalAssigned,
            totalClosed: response?.data?.data?.totalClosed,
            totalLost: response?.data?.data?.totalLost,
            totalPendingAssigned: response?.data?.data?.totalPendingAssigned,
            totalPendingNoAppointment: response?.data?.data?.totalPendingNoAppointment,
            totalInstalled: response?.data?.data?.totalInstalled,
            totalActivated: response?.data?.data?.totalActivated,
            totalLostDisengaged: response?.data?.data?.totalLostDisengaged,
            totalLostFailedCredit: response?.data?.data?.totalLostFailedCredit,
            totalLostCancelled: response?.data?.data?.totalLostCancelled,
            totalNotAssigned: response?.data?.data?.totalNotAssigned,
            pendingInstallKw: response?.data?.data?.pendingInstallKw,
            installedKw: response?.data?.data?.installedKw,
            waitingSignatureKw: response?.data?.data?.waitingSignatureKw,
            waitingSignatureCount: response?.data?.data?.waitingSignatureCount,
            siteSurveyedKw: response?.data?.data?.siteSurveyedKw,
            siteSurveyedCount: response?.data?.data?.siteSurveyedCount,
            pendingInstallCount: response?.data?.data?.pendingInstallCount,
            installedCount: response?.data?.data?.installedCount,
            activatedKw: response?.data?.data?.activatedKw,
            pendingSurveyedCount: response?.data?.data?.pendingSurveyedCount,
            pendingSurveyedKw: response?.data?.data?.pendingSurveyedKw
          });
        } else {
          setSearchResult({
            ...searchResult,
            users: []
          });
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setMyLeadsHeader({
          ...myLeadsHeader,
          loading: false
        });
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  function onSearch(value) {
    search(value, 0);
  }

  const onTableChange = (page, size) => {
    if (page - 1 !== currentPage) {
      setCurrentPage(page - 1);
      search(lastSearchTerm, page - 1);
    } else {
      setPageSize(size);
    }
  };

  function archive(leadId) {
    setLoading(true);
    api.delete(`leads/archive/${leadId}`)
    .then((response) => {
      setLoading(false);
      if (response?.data?.success) {
        search(lastSearchTerm, currentPage);
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setLoading(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    })
  }

  function searchSetters() {
    if (searchText?.length > 0) {
      setSearchingUsers(true);
      api
        .post('leads/setters/search', { Query: searchText, OrganizationReferralCode: leadData?.referralCode })
        .then((response) => {
          setSearchingUsers(false);
          if (response?.data?.success) {
            setSetters(response.data.data.users);
          } else {
            setNotifications([
              ...notifications,
              {
                title: t('error'),
                description: response?.data?.error,
                error: true,
              },
            ]);
          }
        })
        .catch((error) => {
          setSearchingUsers(false);
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: error.message,
              error: true,
            },
          ]);
        });
    } else {
      setSetters([]);
    }
  }

  function assignSetter(setter) {
    setLoading(true);
    api.post('leads/assign/setter', { UserId: setter?.id, LeadId: leadData?.id })
    .then((response) => {
      setLoading(false);
      if (response.data.success) {
        console.log('setter', response.data.data.setter);
        setLeadData({
          ...leadData,
          setterId: response.data.data.setterId,
          setter: response.data.data.setter
        });
        setReloadLeads(true);
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('yay'),
              description: response?.data?.message,
              error: false,
            },
          ]);
        }
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setSearchingUsers(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    });
  }

  function removeSetter() {
    setLoading(true);
    api.delete(`leads/remove/setter/${leadData?.id}`)
    .then((response) => {
      setLoading(false);
      if (response.data.success) {
        console.log('setter', response.data.data.setter);
        setLeadData({
          ...leadData,
          setterId: response.data.data.setterId,
          setter: response.data.data.setter
        });
        setReloadLeads(true);
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('yay'),
              description: response?.data?.message,
              error: false,
            },
          ]);
        }
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setSearchingUsers(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    });
  }

  function revertLost(id) {
    setRevertingLost(true);
    api.post(`leads/revert/${id}`)
    .then((response) => {
      setRevertingLost(false);
      if (response?.data?.success) {
        search(lastSearchTerm, currentPage);
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response?.data?.message,
              error: false,
            },
          ]);
        }
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setRevertingLost(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    })
  }

  useEffect(() => {
    setSetters([]);
    setSearchText('');
    if (!openSetter) {
      setLeadData(null);
    }
  }, [openSetter]);

  const myLeadsColumns = [
    {
      title: '',
      align: 'left',
      className: 'text-sm md:hidden',
      render: (row) => (
        <div className="grid gap-2 grid-cols-2 border border-gray-700 p-2 rounded-md">
          <div className="col-span-2 text-center text-lg space-x-2">
            {/* <strong>{t('client')}: </strong> */}
            <button 
              type="button"
              onClick={() => setView(row)} 
              className="text-primaryColor col-span-2 text-bold hover:underline focus:outline-none"
            >
              <span>
                {/* <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" /> */}
                {row?.submittedBy?.completeName}
              </span>
            </button>
          </div>
          <div className="text-center col-span-2 text-semibold space-x-2">
            {row.externalDealId}
          </div>
          <div className="text-center col-span-2 space-x-2">
            <div className="flex flex-col space-y-2">
              <LeadProgress className="mx-auto" lead={row} />
              <Tag className="" color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
            </div>
          </div>
          <div className="flex-row col-span-2 space-x-2">
          <div className="text-center space-x-2">
            {/* <strong>{t('organization')}: </strong> */}
            <div>
              {row?.referredBy && (
                <div>
                  <span className="">{row?.referredBy?.nameEn}</span>
                  - {t(mapDealType(row.dealType))}       
                </div>
              )}
                {!row?.referredBy && (
                <div className="italic text-gray-400">N/A</div>
              )}  
            </div>
            <div className="text-center col-span-2 space-x-2">
            <>
              {row?.setter && (
                <div>
                  <strong>{t('setter')}: </strong>
                  <span className="">{row?.setter?.completeName}</span>
                </div>
              )}
                {!row?.setter && (
                <div>
                  {t('self-gen')}
                </div>
              )}         
            </>
            </div>
          </div>
          </div>         
          <div className="col-span-2 text-center space-x-2">
            {row.location?.lat !== 0 && row.location?.lon !== 0 && (
              <a
                href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2"
                aria-label={`View location on map for ${row.municipality || 'this place'}`}
              >
                <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
              </a>
            )}
            {row.location?.lat === 0 || row.location?.lon === 0 && (
                 <FontAwesomeIcon icon={faMapMarked} className="text-black" />
            )}
            <span id="municipality-label">
              {row.municipality ? row.municipality : '-'}
            </span>
          </div>
          <div className="col-span-1 space-x-2">
            {(row?.status === 1 || row?.status === 2) && (
              <p>{thousand(row.systemSize)} {t('watts')}</p>
            )}
          </div>         
          <div className="text-center col-span-2 space-x-2 p-4 h-16">
            <Dropdown
              overlay={
                <Menu mode="inline" className="p-0">
                  <Menu.Item
                    id="view"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setView(row);
                    }}
                  >
                    {t('view')}
                  </Menu.Item>
                  <Menu.Item
                    id="appointments"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAppointments(row);
                    }}
                  >
                    {t('appointments')}
                  </Menu.Item>
                  <Menu.Item
                    id="logs"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewLogs(row);
                    }}
                  >
                    {t('notes')}
                  </Menu.Item>
                  <Menu.Item
                    id="files"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewFiles(row);
                    }}
                  >
                    {t('files')}
                  </Menu.Item>
                  <Menu.Item
                    id="contacts"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewContacts(row);
                    }}
                  >
                    {t('contacts')}
                  </Menu.Item>
                  {userPrivilages.hasLeadManager && (
                    <Menu.Item
                      id="viewassigned"
                      className="text-xs flex items-center"
                      onClick={() => {
                        setViewAssigned({
                          ...row,
                          referralCode: row?.referredBy?.referralCode
                        });
                      }}
                    >
                      {t('reassign')}
                    </Menu.Item>
                  )}
                  {row.lostDate && (
                    <Menu.Item
                      id="revert"
                      danger
                      disabled={revertingLost}
                      className="text-xs flex items-center"
                    >
                      <Popconfirm
                        title={t('revert_from_lost_lead_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => revertLost(row.id)}
                      >
                        {t('revert_from_lost')}
                      </Popconfirm>
                    </Menu.Item>
                  )}
                </Menu>
              }
            >
              <Button className="w-full" size="small" type="primary">{t('actions')}</Button>
            </Dropdown>
          </div>
        </div>
      ),
    },
    {
      title: t('client'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <button 
          type="button"
          onClick={() => setView(row)} 
          className="text-primaryColor text-left text-semi-bold hover:underline focus:outline-none"
        >
          <span>
            {/* <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" /> */}
            {row?.submittedBy?.completeName}
          </span>
        </button>
      ),
    },
    {
      title: t('organization'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <>
          {row?.referredBy && (
            <div>
              <span className="">{row?.referredBy?.nameEn}</span>
            </div>
          )}
            {!row?.referredBy && (
            <div className="italic text-gray-400">N/A</div>
          )}         
        </>
      ),
    },
    {
      title: t('setter'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <>
          {row?.setter && (
            <div>
              <span className="">{row?.setter?.completeName}</span>
            </div>
          )}
            {!row?.setter && (
            <div>
              {t('self-gen')}
            </div>
          )}         
        </>
      ),
    },
    {
      title: t('deal_type'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p>{t(mapDealType(row.dealType))}</p>
      ),
    },
    {
      title: t('municipality'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div>     
           {row.location?.lat !== 0 && row.location?.lon !== 0 && (
            <a
              href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2"
              aria-label={`View location on map for ${row.municipality || 'this place'}`}
            >
              <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
            </a>
          )}
          {row.location?.lat === 0 || row.location?.lon === 0 && (
               <FontAwesomeIcon icon={faMapMarked} className="text-black" />
          )}

          <span id="municipality-label">
            {row.municipality ? row.municipality : '-'}
          </span>
        </div>     
      ),
    },
    {
      title: t('deal_id'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p>{row.externalDealId}</p>
      ),
    },
    {
      title: t('property_owner'),
      align: 'center',
      className: 'text-sm hidden',
      render: (row) => (
        <Tag color={`${row.isPropertyOwner ? 'green' : 'red'}`}>{row.isPropertyOwner ? t('yes') : t('no')}</Tag>
      ),
    },
    {
      title: t('size'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div>
          {(row?.status === 1 || row?.status === 2) && !row.systemSize ? <p /> : <p>{thousand(row.systemSize / 1000)} kw</p>}
          {row?.panelSize && row?.batteriesAmount ? <p>({row.panelAmount}/{row.batteriesAmount})</p> : <p />}
        </div>
      ),
    },
    {
      title: t('stage'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className="flex flex-col space-y-2">
          <LeadProgress lead={row} />
          <Tag className="" color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
        </div>
      ),
    },
    {
      title: 
      <span>
       <ClockCircleOutlined style={{ marginRight: 4, fontSize: '16px', color: 'black' }} />
      </span>,
      align: 'left',
      className: 'text-sm hidden',
      render: (row) => (
        <span>{getWaitTimeText(row, t)}</span>
      ),
    },
    {
      title: 
      <span>
       <ClockCircleOutlined className="opacity-0" />
      </span>,
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className="space-x-2 space-y-2">
          <Dropdown
            overlay={
              <Menu mode="inline" className="p-0">
                <Menu.Item
                  id="view"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setView(row);
                  }}
                >
                  {t('view')}
                </Menu.Item>
                <Menu.Item
                  id="appointments"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewAppointments(row);
                  }}
                >
                  {t('appointments')}
                </Menu.Item>
                <Menu.Item
                  id="logs"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewLogs(row);
                  }}
                >
                  {t('notes')}
                </Menu.Item>
                <Menu.Item
                  id="files"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewFiles(row);
                  }}
                >
                  {t('files')}
                </Menu.Item>
                <Menu.Item
                  id="contacts"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewContacts(row);
                  }}
                >
                  {t('contacts')}
                </Menu.Item>
                {userPrivilages.hasLeadManager && (
                  <Menu.Item
                    id="viewassigned"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAssigned({
                        ...row,
                        referralCode: row?.referredBy?.referralCode
                      });
                    }}
                  >
                    {t('reassign')}
                  </Menu.Item>
                )}
                {row.lostDate && (
                  <Menu.Item
                    id="revert"
                    danger
                    disabled={revertingLost}
                    className="text-xs flex items-center"
                  >
                    <Popconfirm
                      title={t('revert_from_lost_lead_prompt')}
                      okText={t('yes')}
                      cancelText={t('no')}
                      onConfirm={() => revertLost(row.id)}
                    >
                      {t('revert_from_lost')}
                    </Popconfirm>
                  </Menu.Item>
                )}
              </Menu>
            }
          >
            <Button size="small" type="primary">{t('actions')}</Button>
          </Dropdown>
        </div>
      ),
    }
  ];

  const globalColumns = [
    {
      title: '',
      align: 'center',
      className: 'text-sm w-full md:hidden',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'} grid gap-2 grid-cols-2`}>
          <div className="col-span-2 text-center space-x-2">
            <span>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</span>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('client')}: </strong>
            <button 
              type="button"
              onClick={() => setView(row)} 
              className="text-primaryColor col-span-2 text-semi-bold hover:underline focus:outline-none"
            >
              <span>
                <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                {row?.submittedBy?.completeName}
              </span>
            </button>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('organization')}: </strong>
            <>
              {row?.referredBy && (
                <div>
                  <span className="">{row?.referredBy?.nameEn}</span>
                </div>
              )}
                {!row?.referredBy && (
                <div className="italic text-gray-400">N/A</div>
              )}         
            </>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('closer')}: </strong>
            <>
              {_.filter(row?.assignments, (a) => a.ownershipType === 0).length > 0 && (
                <span>
                  <Avatar src={_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                  {_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.completeName}
                </span>
              )}
              {_.filter(row?.assignments, (a) => a.ownershipType === 0).length === 0 && (
                <span>-</span>
              )}
            </>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('setter')}: </strong>
            <>
              {row?.setter && (
                <div>
                  <span className="">{row?.setter?.completeName}</span>
                </div>
              )}
                {!row?.setter && (
                <div>
                  {t('self-gen')}
                </div>
              )}         
            </>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <p><span className="font-bold">{t('deal_type')}:</span> {t(mapDealType(row.dealType))}</p>
          </div>
          <div className="col-span-2 space-x-2">
            {row.location?.lat !== 0 && row.location?.lon !== 0 && (
              <a
                href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2"
                aria-label={`View location on map for ${row.municipality || 'this place'}`}
              >
                <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
              </a>
            )}
            {row.location?.lat === 0 || row.location?.lon === 0 && (
                 <FontAwesomeIcon icon={faMapMarked} className="text-black" />
            )}
            <span id="municipality-label">
              {row.municipality ? row.municipality : '-'}
            </span>
          </div>
          {/* <div className="text-right col-span-1 space-x-2">
            {row.externalDealId}
          </div>
          <div className="col-span-1 space-x-2">
            {(row?.status === 1 || row?.status === 2) && (
              <p>{thousand(row.systemSize)} {t('watts')}</p>
            )}
          </div> */}
          <div className="text-center col-span-2 space-x-2">
            <Tag color={`${row.assignments.length === 0 ? 'red' : 'green'}`}>{`${row.assignments.length === 0 ? t('available') : t('assigned')}`}</Tag>
          </div>
          <div className="text-center col-span-2 space-x-2">
            <Tag color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
          </div>
          <div className="text-center col-span-2 space-x-2">
            <div className="space-x-2 space-y-2">
              {userPrivilages.hasCloserManagerPrivilages && (
                <Dropdown
                  overlay={
                    <Menu mode="inline" className="p-0">
                      <Menu.Item
                        id="view"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setView(row);
                        }}
                      >
                        {t('view')}
                      </Menu.Item>
                      <Menu.Item
                        id="appointments"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewAppointments(row);
                        }}
                      >
                        {t('appointments')}
                      </Menu.Item>
                      <Menu.Item
                        id="notes"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewLogs(row);
                        }}
                      >
                        {t('notes')}
                      </Menu.Item>
                      <Menu.Item
                        id="viewassigned"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewAssigned({
                            ...row,
                            referralCode: orgReferral
                          });
                        }}
                      >
                        {t('view_assigned')}
                      </Menu.Item>
                      {useGlobal && !orgReferral && (
                        <Menu.Item
                          id="setter"
                          className="text-xs flex items-center"
                          onClick={() => {
                            setLeadData(row);
                            setOpenSetter(true);
                          }}
                        >
                          {t('setter')}
                        </Menu.Item>
                      )}
                      {useGlobal && !orgReferral && (
                        <Menu.Item
                          id="assignorg"
                          className="text-xs flex items-center"
                          onClick={() => setAssignOrg(row)}
                        >
                          {t('assign_org')}
                        </Menu.Item>
                      )}
                      {userPrivilages.hasCloserAdminPrivilages && (
                        <>
                          <Menu.Item
                            id="commissions"
                            className="text-xs flex items-center"
                            onClick={() => setEditCommissions(row)}
                          >
                            {t('commissions')}
                          </Menu.Item>
                          <Menu.Item
                            id="payout"
                            className="text-xs flex items-center"
                            onClick={() => setViewPayout(row)}
                          >
                            {t('payout')}
                          </Menu.Item>
                        </>
                      )}
                      {userPrivilages.hasOrganizationAdminPrivilages && (
                        <Menu.Item
                          id="archive"
                          danger
                          className="text-xs flex items-center"
                        >
                          <Popconfirm
                            title={t('archive_lead_prompt')}
                            okText={t('yes')}
                            cancelText={t('no')}
                            onConfirm={() => archive(row.id)}
                          >
                            {t('archive')}
                          </Popconfirm>
                        </Menu.Item>
                      )}
                      {row.lostDate && (
                        <Menu.Item
                          id="revert"
                          danger
                          disabled={revertingLost}
                          className="text-xs flex items-center"
                        >
                          <Popconfirm
                            title={t('revert_from_lost_lead_prompt')}
                            okText={t('yes')}
                            cancelText={t('no')}
                            onConfirm={() => revertLost(row.id)}
                          >
                            {t('revert_from_lost')}
                          </Popconfirm>
                        </Menu.Item>
                      )}
                    </Menu>
                  }
                >
                  <Button size="small" className="w-full" type="primary">{t('actions')}</Button>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: t('created_on'),
      width: 200,
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span className={`${row.hasCloser ? '' : 'text-red-400'}`}>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</span>
      ),
    },
    {
      title: t('organization'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {row?.referredBy && (
            <div>
              <span className="">{row?.referredBy?.nameEn}</span>
            </div>
          )}
            {!row?.referredBy && (
            <div className="italic text-gray-400">N/A</div>
          )}         
        </div>
      ),
    },
    {
      title: t('client'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {/* <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" /> */}
          {row?.submittedBy?.completeName}
        </span>
      ),
    },
    {
      title: t('closer'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {_.filter(row?.assignments, (a) => a.ownershipType === 0).length > 0 && (
            <span>
              <Avatar src={_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
              {_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.completeName}
            </span>
          )}
          {_.filter(row?.assignments, (a) => a.ownershipType === 0).length === 0 && (
            <span>-</span>
          )}
        </div>
      ),
    },
    {
      title: t('setter'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {row?.setter && (
            <span>
              <Avatar src={row?.setter?.avatar} className=" bg-primaryColor h12 w-8 mr-2" />
              {row?.setter?.completeName}
            </span>
          )}
          {!row?.setter && (
            <span>{t('self-gen')}</span>
          )}
        </div>
      ),
    },
    {
      title: t('deal_type'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p className={`${row.hasCloser ? '' : 'text-red-400'}`}>{t(mapDealType(row.dealType))}</p>
      ),
    },
    {
      title: t('deal_type'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p className={`${row.hasCloser ? '' : 'text-red-400'}`}>{t(mapDealType(row.dealType))}</p>
      ),
    },
    {
      title: t('municipality'),
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span className={`${row.hasCloser ? '' : 'text-red-400'}`}>{row.municipality ? row.municipality : '-'}</span>
      ),
    },
    {
      title: t('property_owner'),
      align: 'center',
      className: 'text-sm hidden',
      render: (row) => (
        <Tag color={`${row.isPropertyOwner ? 'green' : 'red'}`}>{row.isPropertyOwner ? t('yes') : t('no')}</Tag>
      ),
    },
    {
      title: t('status'),
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <Tag color={`${row.assignments.length === 0 ? 'red' : 'green'}`}>{`${row.assignments.length === 0 ? t('available') : t('assigned')}`}</Tag>
      ),
    },
    {
      title: t('stage'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <Tag color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
      ),
    },
    // {
    //   title: t('wait_time'),
    //   align: 'center',
    //   className: 'text-sm',
    //   render: (row) => (
    //     <span>{getWaitTimeText(row.createdAt, t)}</span>
    //   ),
    // },
    {
      title: '',
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className="space-x-2 space-y-2">
          {userPrivilages.hasCloserManagerPrivilages && (
            <Dropdown
              overlay={
                <Menu mode="inline" className="p-0">
                  <Menu.Item
                    id="view"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setView(row);
                    }}
                  >
                    {t('view')}
                  </Menu.Item>
                  <Menu.Item
                    id="appointments"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAppointments(row);
                    }}
                  >
                    {t('appointments')}
                  </Menu.Item>
                  <Menu.Item
                    id="notes"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewLogs(row);
                    }}
                  >
                    {t('notes')}
                  </Menu.Item>
                  <Menu.Item
                    id="viewassigned"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAssigned({
                        ...row,
                        referralCode: orgReferral
                      });
                    }}
                  >
                    {t('view_assigned')}
                  </Menu.Item>
                  {useGlobal && !orgReferral && (
                    <Menu.Item
                      id="setter"
                      className="text-xs flex items-center"
                      onClick={() => {
                        setLeadData(row);
                        setOpenSetter(true);
                      }}
                    >
                      {t('setter')}
                    </Menu.Item>
                  )}
                  {useGlobal && !orgReferral && (
                    <Menu.Item
                      id="assignorg"
                      className="text-xs flex items-center"
                      onClick={() => setAssignOrg(row)}
                    >
                      {t('assign_org')}
                    </Menu.Item>
                  )}
                  {userPrivilages.hasCloserAdminPrivilages && (
                    <>
                      <Menu.Item
                        id="commissions"
                        className="text-xs flex items-center"
                        onClick={() => setEditCommissions(row)}
                      >
                        {t('commissions')}
                      </Menu.Item>
                      <Menu.Item
                        id="payout"
                        className="text-xs flex items-center"
                        onClick={() => setViewPayout(row)}
                      >
                        {t('payout')}
                      </Menu.Item>
                    </>
                  )}
                  {userPrivilages.hasOrganizationAdminPrivilages && (
                    <Menu.Item
                      id="archive"
                      danger
                      className="text-xs flex items-center"
                    >
                      <Popconfirm
                        title={t('archive_lead_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => archive(row.id)}
                      >
                        {t('archive')}
                      </Popconfirm>
                    </Menu.Item>
                  )}
                  {row.lostDate && (
                    <Menu.Item
                      id="revert"
                      danger
                      disabled={revertingLost}
                      className="text-xs flex items-center"
                    >
                      <Popconfirm
                        title={t('revert_from_lost_lead_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => revertLost(row.id)}
                      >
                        {t('revert_from_lost')}
                      </Popconfirm>
                    </Menu.Item>
                  )}
                </Menu>
              }
            >
              <Button size="small" type="primary">{t('actions')}</Button>
            </Dropdown>
          )}
        </div>
      ),
    },
  ];

  const orgColumns = [
    {
      title: '',
      align: 'center',
      className: 'text-sm w-full md:hidden',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'} grid gap-2 grid-cols-2`}>
          <div className="col-span-2 text-center space-x-2">
            <span>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</span>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('client')}: </strong>
            <button 
              type="button"
              onClick={() => setView(row)} 
              className="text-primaryColor col-span-2 text-semi-bold hover:underline focus:outline-none"
            >
              <span>
                <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                {row?.submittedBy?.completeName}
              </span>
            </button>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('closer')}: </strong>
            <>
              {_.filter(row?.assignments, (a) => a.ownershipType === 0).length > 0 && (
                <span>
                  <Avatar src={_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                  {_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.completeName}
                </span>
              )}
              {_.filter(row?.assignments, (a) => a.ownershipType === 0).length === 0 && (
                <span>-</span>
              )}
            </>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('setter')}: </strong>
            <>
              {row?.setter && (
                <div>
                  <span className="">{row?.setter?.completeName}</span>
                </div>
              )}
                {!row?.setter && (
                <div>
                  {t('self-gen')}
                </div>
              )}         
            </>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <p><span className="font-bold">{t('deal_type')}:</span> {t(mapDealType(row.dealType))}</p>
          </div>
          <div className="col-span-2 space-x-2">
            {row.location?.lat !== 0 && row.location?.lon !== 0 && (
              <a
                href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2"
                aria-label={`View location on map for ${row.municipality || 'this place'}`}
              >
                <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
              </a>
            )}
            {row.location?.lat === 0 || row.location?.lon === 0 && (
                 <FontAwesomeIcon icon={faMapMarked} className="text-black" />
            )}
            <span id="municipality-label">
              {row.municipality ? row.municipality : '-'}
            </span>
          </div>
          {/* <div className="text-right col-span-1 space-x-2">
            {row.externalDealId}
          </div>
          <div className="col-span-1 space-x-2">
            {(row?.status === 1 || row?.status === 2) && (
              <p>{thousand(row.systemSize)} {t('watts')}</p>
            )}
          </div> */}
          <div className="text-center col-span-2 space-x-2">
            <Tag color={`${row.assignments.length === 0 ? 'red' : 'green'}`}>{`${row.assignments.length === 0 ? t('available') : t('assigned')}`}</Tag>
          </div>
          <div className="text-center col-span-2 space-x-2">
            <Tag color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
          </div>
          <div className="text-center col-span-2 space-x-2">
            <div className="space-x-2 space-y-2">
              {/* {(!showRequestButton(row).isAssigned && !showRequestButton(row).isRequested) && (
                <Button
                  size="small"
                  type="primary"
                  loading={row.loading}
                  onClick={() => requestLead(row)}
                >
                  {t('request')}
                </Button>
              )}
              {showRequestButton(row).isRequested && !showRequestButton(row).isAssigned && (
                <Button
                  size="small"
                  type="primary"
                  disabled
                >
                  {t('requested')}
                </Button>
              )}
              {showRequestButton(row).isAssigned && (
                <Dropdown
                  overlay={
                    <Menu mode="inline" className="p-0">
                      <Menu.Item
                        id="view"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setView(row);
                        }}
                      >
                        {t('view')}
                      </Menu.Item>
                      <Menu.Item
                        id="logs"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewLogs(row);
                        }}
                      >
                        {t('notes')}
                      </Menu.Item>
                      <Menu.Item
                        id="files"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewFiles(row);
                        }}
                      >
                        {t('files')}
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <Button size="small" type="primary">{t('actions')}</Button>
                </Dropdown>
              )} */}
              {userPrivilages.hasCloserManagerPrivilages && (
                <Dropdown
                  overlay={
                    <Menu mode="inline" className="p-0">
                      <Menu.Item
                        id="view"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setView(row);
                        }}
                      >
                        {t('view')}
                      </Menu.Item>
                      <Menu.Item
                        id="appointments"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewAppointments(row);
                        }}
                      >
                        {t('appointments')}
                      </Menu.Item>
                      <Menu.Item
                        id="notes"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewLogs(row);
                        }}
                      >
                        {t('notes')}
                      </Menu.Item>
                      <Menu.Item
                        id="viewassigned"
                        className="text-xs flex items-center"
                        onClick={() => {
                          setViewAssigned({
                            ...row,
                            referralCode: orgReferral
                          });
                        }}
                      >
                        {t('view_assigned')}
                      </Menu.Item>
                      {useGlobal && !orgReferral && (
                        <Menu.Item
                          id="setter"
                          className="text-xs flex items-center"
                          onClick={() => {
                            setLeadData(row);
                            setOpenSetter(true);
                          }}
                        >
                          {t('setter')}
                        </Menu.Item>
                      )}
                      {useGlobal && !orgReferral && (
                        <Menu.Item
                          id="assignorg"
                          className="text-xs flex items-center"
                          onClick={() => setAssignOrg(row)}
                        >
                          {t('assign_org')}
                        </Menu.Item>
                      )}
                      {userPrivilages.hasCloserAdminPrivilages && (
                        <>
                          <Menu.Item
                            id="commissions"
                            className="text-xs flex items-center"
                            onClick={() => setEditCommissions(row)}
                          >
                            {t('commissions')}
                          </Menu.Item>
                          <Menu.Item
                            id="payout"
                            className="text-xs flex items-center"
                            onClick={() => setViewPayout(row)}
                          >
                            {t('payout')}
                          </Menu.Item>
                        </>
                      )}
                      {userPrivilages.hasOrganizationAdminPrivilages && (
                        <Menu.Item
                          id="archive"
                          danger
                          className="text-xs flex items-center"
                        >
                          <Popconfirm
                            title={t('archive_lead_prompt')}
                            okText={t('yes')}
                            cancelText={t('no')}
                            onConfirm={() => archive(row.id)}
                          >
                            {t('archive')}
                          </Popconfirm>
                        </Menu.Item>
                      )}
                      {row.lostDate && (
                        <Menu.Item
                          id="revert"
                          danger
                          disabled={revertingLost}
                          className="text-xs flex items-center"
                        >
                          <Popconfirm
                            title={t('revert_from_lost_lead_prompt')}
                            okText={t('yes')}
                            cancelText={t('no')}
                            onConfirm={() => revertLost(row.id)}
                          >
                            {t('revert_from_lost')}
                          </Popconfirm>
                        </Menu.Item>
                      )}
                    </Menu>
                  }
                >
                  <Button size="small" className="w-full" type="primary">{t('actions')}</Button>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: t('created_on'),
      width: 200,
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span className={`${row.hasCloser ? '' : 'text-red-400'}`}>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</span>
      ),
    },
    {
      title: t('client'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {/* <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" /> */}
          {row?.submittedBy?.completeName}
        </span>
      ),
    },
    {
      title: t('closer'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {_.filter(row?.assignments, (a) => a.ownershipType === 0).length > 0 && (
            <span>
              <Avatar src={_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
              {_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.completeName}
            </span>
          )}
          {_.filter(row?.assignments, (a) => a.ownershipType === 0).length === 0 && (
            <span>-</span>
          )}
        </div>
      ),
    },
    {
      title: t('setter'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className={`${row.hasCloser ? '' : 'text-red-400'}`}>
          {row?.setter && (
            <span>
              <Avatar src={row?.setter?.avatar} className=" bg-primaryColor h12 w-8 mr-2" />
              {row?.setter?.completeName}
            </span>
          )}
          {!row?.setter && (
            <span>{t('self-gen')}</span>
          )}
        </div>
      ),
    },
    {
      title: t('deal_type'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p className={`${row.hasCloser ? '' : 'text-red-400'}`}>{t(mapDealType(row.dealType))}</p>
      ),
    },
    {
      title: t('municipality'),
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span className={`${row.hasCloser ? '' : 'text-red-400'}`}>{row.municipality ? row.municipality : '-'}</span>
      ),
    },
    {
      title: t('property_owner'),
      align: 'center',
      className: 'text-sm hidden',
      render: (row) => (
        <Tag color={`${row.isPropertyOwner ? 'green' : 'red'}`}>{row.isPropertyOwner ? t('yes') : t('no')}</Tag>
      ),
    },
    {
      title: t('status'),
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <Tag color={`${row.assignments.length === 0 ? 'red' : 'green'}`}>{`${row.assignments.length === 0 ? t('available') : t('assigned')}`}</Tag>
      ),
    },
    {
      title: t('stage'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <Tag color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
      ),
    },
    // {
    //   title: t('wait_time'),
    //   align: 'center',
    //   className: 'text-sm',
    //   render: (row) => (
    //     <span>{getWaitTimeText(row.createdAt, t)}</span>
    //   ),
    // },
    {
      title: '',
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className="space-x-2 space-y-2">
          {userPrivilages.hasCloserManagerPrivilages && (
            <Dropdown
              overlay={
                <Menu mode="inline" className="p-0">
                  <Menu.Item
                    id="view"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setView(row);
                    }}
                  >
                    {t('view')}
                  </Menu.Item>
                  <Menu.Item
                    id="appointments"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAppointments(row);
                    }}
                  >
                    {t('appointments')}
                  </Menu.Item>
                  <Menu.Item
                    id="notes"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewLogs(row);
                    }}
                  >
                    {t('notes')}
                  </Menu.Item>
                  <Menu.Item
                    id="viewassigned"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAssigned({
                        ...row,
                        referralCode: orgReferral
                      });
                    }}
                  >
                    {t('view_assigned')}
                  </Menu.Item>
                  {useGlobal && !orgReferral && (
                    <Menu.Item
                      id="setter"
                      className="text-xs flex items-center"
                      onClick={() => {
                        setLeadData(row);
                        setOpenSetter(true);
                      }}
                    >
                      {t('setter')}
                    </Menu.Item>
                  )}
                  {useGlobal && !orgReferral && (
                    <Menu.Item
                      id="assignorg"
                      className="text-xs flex items-center"
                      onClick={() => setAssignOrg(row)}
                    >
                      {t('assign_org')}
                    </Menu.Item>
                  )}
                  {userPrivilages.hasCloserAdminPrivilages && (
                    <>
                      <Menu.Item
                        id="commissions"
                        className="text-xs flex items-center"
                        onClick={() => setEditCommissions(row)}
                      >
                        {t('commissions')}
                      </Menu.Item>
                      <Menu.Item
                        id="payout"
                        className="text-xs flex items-center"
                        onClick={() => setViewPayout(row)}
                      >
                        {t('payout')}
                      </Menu.Item>
                    </>
                  )}
                  {userPrivilages.hasOrganizationAdminPrivilages && (
                    <Menu.Item
                      id="archive"
                      danger
                      className="text-xs flex items-center"
                    >
                      <Popconfirm
                        title={t('archive_lead_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => archive(row.id)}
                      >
                        {t('archive')}
                      </Popconfirm>
                    </Menu.Item>
                  )}
                  {row.lostDate && (
                    <Menu.Item
                      id="revert"
                      danger
                      disabled={revertingLost}
                      className="text-xs flex items-center"
                    >
                      <Popconfirm
                        title={t('revert_from_lost_lead_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => revertLost(row.id)}
                      >
                        {t('revert_from_lost')}
                      </Popconfirm>
                    </Menu.Item>
                  )}
                </Menu>
              }
            >
              <Button size="small" type="primary">{t('actions')}</Button>
            </Dropdown>
          )}
        </div>
      ),
    },
  ];

  const setterColumns = [
    {
      title: '',
      align: 'left',
      className: 'text-sm w-full md:hidden',
      render: (row) => (
        <div className="grid gap-2 grid-cols-2">
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('client')}: </strong>
            <button 
              type="button"
              onClick={() => setView(row)} 
              className="text-primaryColor col-span-2 text-semi-bold hover:underline focus:outline-none"
            >
              <span>
                <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                {row?.submittedBy?.completeName}
              </span>
            </button>
          </div>
          <div className="col-span-2 text-center space-x-2">
            <strong>{t('closer')}: </strong>
            {_.filter(row?.assignments, (a) => a.ownershipType === 0).length > 0 && (
              <span>
                <Avatar src={_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                {_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.completeName}
              </span>
            )}
            {_.filter(row?.assignments, (a) => a.ownershipType === 0).length === 0 && (
              <span>-</span>
            )}
          </div>
          <div className="col-span-2 text-center space-x-2">
            <p><span className="font-bold">{t('deal_type')}:</span> {t(mapDealType(row.dealType))}</p>
          </div>
          <div className="col-span-1 space-x-2">
            {row.location?.lat !== 0 && row.location?.lon !== 0 && (
              <a
                href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2"
                aria-label={`View location on map for ${row.municipality || 'this place'}`}
              >
                <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
              </a>
            )}
            {row.location?.lat === 0 || row.location?.lon === 0 && (
                 <FontAwesomeIcon icon={faMapMarked} className="text-black" />
            )}
            <span id="municipality-label">
              {row.municipality ? row.municipality : '-'}
            </span>
          </div>
          <div className="text-right col-span-1 space-x-2">
            {row.externalDealId}
          </div>
          <div className="col-span-1 space-x-2">
            {(row?.status === 1 || row?.status === 2) && (
              <p>{thousand(row.systemSize)} {t('watts')}</p>
            )}
          </div>
          <div className="text-center col-span-2 space-x-2">
            <Tag color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
          </div>
          <div className="text-center col-span-2 space-x-2">
            <LeadProgress lead={row} />
          </div>
          <div className="text-center col-span-2 space-x-2">
            <Dropdown
              overlay={
                <Menu mode="inline" className="p-0">
                  <Menu.Item
                    id="view"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setView({
                        ...row,
                        asSetter: true
                      });
                    }}
                  >
                    {t('view')}
                  </Menu.Item>
                  <Menu.Item
                    id="appointments"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewAppointments({
                        ...row,
                        asSetter: true
                      });
                    }}
                  >
                    {t('appointments')}
                  </Menu.Item>
                  <Menu.Item
                    id="logs"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewLogs({
                        ...row,
                        asSetter: true
                      });
                    }}
                  >
                    {t('notes')}
                  </Menu.Item>
                  <Menu.Item
                    id="files"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewFiles({
                        ...row,
                        asSetter: true
                      });
                    }}
                  >
                    {t('files')}
                  </Menu.Item>
                  <Menu.Item
                    id="contacts"
                    className="text-xs flex items-center"
                    onClick={() => {
                      setViewContacts({
                        ...row,
                        asSetter: true
                      });
                    }}
                  >
                    {t('contacts')}
                  </Menu.Item>
                </Menu>
              }
            >
              <Button className="sm:w-full" size="small" type="primary">{t('actions')}</Button>
            </Dropdown>
          </div>
        </div>
      ),
    },
    {
      title: t('client'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <button 
          type="button"
          onClick={() => setView(row)} 
          className="text-primaryColor text-left text-semi-bold hover:underline focus:outline-none"
        >
          <span>
            <Avatar src={row?.submittedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
            {row?.submittedBy?.completeName}
          </span>
        </button>
      ),
    },
    {
      title: t('closer'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <>
          {_.filter(row?.assignments, (a) => a.ownershipType === 0).length > 0 && (
            <span>
              <Avatar src={_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
              {_.filter(row?.assignments, (a) => a.ownershipType === 0)[0].assignedTo?.completeName}
            </span>
          )}
          {_.filter(row?.assignments, (a) => a.ownershipType === 0).length === 0 && (
            <span>-</span>
          )}
        </>
      ),
    },
    {
      title: t('deal_type'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p>{t(mapDealType(row.dealType))}</p>
      ),
    },
    {
      title: t('municipality'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div>     
           {row.location?.lat !== 0 && row.location?.lon !== 0 && (
            <a
              href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2"
              aria-label={`View location on map for ${row.municipality || 'this place'}`}
            >
              <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
            </a>
          )}
          {row.location?.lat === 0 || row.location?.lon === 0 && (
               <FontAwesomeIcon icon={faMapMarked} className="text-black" />
          )}

          <span id="municipality-label">
            {row.municipality ? row.municipality : '-'}
          </span>
        </div>     
      ),
    },
    {
      title: t('deal_id'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <p>{row.externalDealId}</p>
      ),
    },
    {
      title: t('size'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        row?.status === 1 || row?.status === 2 ? '' : <p>{thousand(row.systemSize)} {t('watts')}</p>
      ),
    },
    {
      title: t('stage'),
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <Tag color={mapLeadProgressColor(row)}>{t(mapLeadStatus(row.status))} {getWaitTimeText(row, t)}</Tag>
      ),
    },
    {
      title: t('progress'),
      align: 'left',  
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <LeadProgress lead={row} />
      ),
    },
    {
      title: 
      <span>
       <ClockCircleOutlined style={{ marginRight: 4, fontSize: '16px', color: 'black' }} />
      </span>,
      align: 'left',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <span>{getWaitTimeText(row, t)}</span>
      ),
    },
    {
      title: 
      <span>
       <ClockCircleOutlined className="opacity-0" />
      </span>,
      align: 'center',
      className: 'text-sm hidden md:table-cell',
      render: (row) => (
        <div className="space-x-2 space-y-2">
          <Dropdown
            overlay={
              <Menu mode="inline" className="p-0">
                <Menu.Item
                  id="view"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setView({
                      ...row,
                      asSetter: true
                    });
                  }}
                >
                  {t('view')}
                </Menu.Item>
                <Menu.Item
                  id="logs"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewLogs({
                      ...row,
                      asSetter: true
                    });
                  }}
                >
                  {t('notes')}
                </Menu.Item>
                <Menu.Item
                  id="appointments"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewAppointments({
                      ...row,
                      asSetter: true
                    });
                  }}
                >
                  {t('appointments')}
                </Menu.Item>
                <Menu.Item
                  id="files"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewFiles({
                      ...row,
                      asSetter: true
                    });
                  }}
                >
                  {t('files')}
                </Menu.Item>
                <Menu.Item
                  id="contacts"
                  className="text-xs flex items-center"
                  onClick={() => {
                    setViewContacts({
                      ...row,
                      asSetter: true
                    });
                  }}
                >
                  {t('contacts')}
                </Menu.Item>
              </Menu>
            }
          >
            <Button size="small" type="primary">{t('actions')}</Button>
          </Dropdown>
        </div>
      ),
    }
  ];

  useEffect(() => {
    search(lastSearchTerm, 0);
  }, [searchType, pageSize, selectedSort]);

  useEffect(() => {
    if (createNewLead?.reload) {
      search(lastSearchTerm, 0);
      setCreateNewLead({
        ...createNewLead,
        reload: false
      });
    }
  }, [createNewLead?.reload])

  useEffect(() => {
    if (reloadLeads) {
      setReloadLeads(false);
      search(lastSearchTerm, currentPage);
    }
  }, [reloadLeads]);

  useEffect(() => {
    // search('', 0);
  }, []);

  return (
    <div className={className}>
      <div className="lg:flex items-center space-x-2 justify-center">
        <Input.Search
          placeholder={`${t('search')}...`}
          allowClear
          disabled={loading}
          className="mt-4"
          enterButton={t('search')}
          size="large"
          onSearch={(val) => onSearch(val)}
        />
        {useGlobal && (
          <>
            <Select
              showSearch
              className="h-12 mt-4 w-full md:w-48"
              filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
              value={selectedCloserId}
              disabled={loading}
              onChange={(obj) => setSelectedCloserId(obj)}
            >
              <Option value="">{t('any_closer')}</Option>
              {_.map(_.orderBy(myLeadsHeader?.closers, (c1) => c1.completeName), (c) => (
                <Option value={c.id}>{c.completeName}</Option>
              ))}
            </Select>
            <Select
              showSearch
              className="h-12 mt-4 w-full md:w-48"
              filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
              value={selectedSetterId}
              disabled={loading}
              onChange={(obj) => setSelectedSetterId(obj)}
            >
              <Option value="">{t('any_setter')}</Option>
              {_.map(_.orderBy(myLeadsHeader?.setters, (c1) => c1.completeName), (c) => (
                <Option value={c.id}>{c.completeName}</Option>
              ))}
            </Select>
          </>
        )}
        <Select
          className="h-12 mt-4 w-full md:w-48"
          value={selectedSort}
          disabled={loading}
          onChange={(obj) => setSelectedSort(obj)}
        >
          <Option value={0}>{t('created_on')} <FontAwesomeIcon className="ml-2" icon={faArrowDown} /></Option>
          <Option value={1}>{t('created_on')} <FontAwesomeIcon className="ml-2" icon={faArrowUp} /></Option>
          <Option value={2}>{t('stage')} <FontAwesomeIcon className="ml-2" icon={faArrowDown} /></Option>
          <Option value={3}>{t('stage')} <FontAwesomeIcon className="ml-2" icon={faArrowUp} /></Option>
        </Select>
      </div>
      <div className="mt-4">{t('showing')}: {searchResult?.total ?? 0}</div>
      <Table
        locale={{
          emptyText: t('no_data')
        }}
        bordered
        rowKey="id"
        pagination={{
          pageSize,
          showSizeChanger: true,
          current: currentPage + 1,
          total: searchResult?.total,
          onChange: onTableChange
        }}
        loading={loading}
        dataSource={searchResult?.submissions}
        columns={useGlobal && !orgReferral ? globalColumns : (useGlobal && orgReferral ? orgColumns : (isSetter ? setterColumns : myLeadsColumns))}
      />
      <Modal
        title={t('setter')}
        zIndex={999}
        open={openSetter}
        onCancel={() => setOpenSetter(false)}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => setOpenSetter(false)}
          >
            {t('close')}
          </Button>
        ]}
      >
        <div className="flex space-x-2">
          <Dropdown
            trigger="click"
            placement="bottom"
            overlay={
              <Menu>
                {_.map(setters, (u) => (
                  <Popconfirm
                    title={t('assign_user_to_lead_prompt')}
                    okText={t('yes')}
                    cancelText={t('no')}
                    onConfirm={() => {
                      assignSetter(u);
                      setSearchText('');
                      setSetters([]);
                    }}
                  >
                    <Menu.Item
                      key={u.id}
                    >
                      <span>
                        <Avatar src={u.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                        {u.completeName}: {u.email}
                      </span>
                    </Menu.Item>
                  </Popconfirm>
                ))}
              </Menu>
            }
          >
            <Input.Search
              placeholder={`${t('search_users')}...`}
              allowClear
              className="mt-4"
              disabled={loading}
              loading={searchingUsers}
              enterButton={t('search')}
              size="small"
              value={searchText}
              onChange={(obj) => {
                setSearchText(obj.target.value);
                if (obj.target.value.length === 0) {
                  setSetters([]);
                }
              }}
              onClear={() => setSetters([])}
              onSearch={(val) => searchSetters()}
            />
          </Dropdown>
        </div>
        <Divider orientation="left">
          {t('assigned_setter')}
        </Divider>
        {leadData?.setter && (
          <div className="flex">
            <span>
              <Avatar src={leadData?.setter?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
              {leadData?.setter?.completeName}
            </span>
            <Popconfirm
              title={t('remove_setter_prompt')}
              okText={t('yes')}
              cancelText={t('no')}
              onConfirm={() => removeSetter()}
            >
              <button className="text-red-400 text-lg ml-auto" aria-label={t('remove_setter')} type="button">
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
            </Popconfirm>
          </div>
        )}
        {!leadData?.setter && (
          <div className="text-gray-400 text-center italic">N/A</div>
        )}
      </Modal>
    </div>
  );
}

export default LeadsSearchTable;
